import { render, staticRenderFns } from "./ReferralPromotionById.vue?vue&type=template&id=31371e78&"
import script from "./ReferralPromotionById.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionById.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPromotionById.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31371e78')) {
      api.createRecord('31371e78', component.options)
    } else {
      api.reload('31371e78', component.options)
    }
    module.hot.accept("./ReferralPromotionById.vue?vue&type=template&id=31371e78&", function () {
      api.rerender('31371e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionById.vue"
export default component.exports